module.exports = __webpack_public_path__ + "assets/img/button-marriage.a4ce240e.png";